function getWholesalePrice(price?: number | null, wholesaleDiscount?: number | null) {
  const validPrice = price ?? 0;
  const validDiscount = wholesaleDiscount ?? 0;

  // Validate inputs
  if (validPrice < 0 || validDiscount < 0 || validDiscount > 100) {
    return 0;
  }

  return validPrice - validPrice * (validDiscount / 100);
}

function getDiscount(price?: number | null, wholesalePrice?: number | null) {
  const validPrice = price ?? 0;
  const validWholesalePrice = wholesalePrice ?? 0;

  // Validate inputs
  if (validPrice < 0 || validWholesalePrice < 0) {
    return 0;
  }

  // Prevent division by zero
  if (validPrice === 0) {
    return 0;
  }

  // Calculate discount percentage
  const discount = ((validPrice - validWholesalePrice) / validPrice) * 100;

  // Ensure discount is within valid range (0-100%)
  return Math.max(0, Math.min(100, discount));
}

export const wholesaleValueConverter = {
  getWholesalePrice,
  getDiscount,
};
